import { Home, MessageCircle, User, type LucideIcon } from 'lucide-react'

export interface NavConfigInterface {
    // [key: string]: NavConfigElement[]
    main: NavConfigElement[]
    main_sub: NavConfigElement[]
    system: NavConfigElement[]
}

export interface NavConfigElement {
    key: string
    label: string
    path: string
    visible: boolean
    icon: LucideIcon
    new_tab: boolean
    onboardingId?: string
}

export class NavConfig {
    public static get(): NavConfigInterface {
        return this.getConfig()
    }

    private static getConfig = (): NavConfigInterface => {
        return {
            // main: [this.Home, this.Chat, this.StrengthsAnalysis, this.Careers, this.Tasks],
            main: [this.Chat, this.Profile],
            main_sub: [],
            system: [],
        }
    }

    private static Home = {
        key: 'home',
        label: 'Home',
        path: '/',
        visible: true,
        icon: Home,
        new_tab: false,
        // onboardingId: onboardingElementConfig.start.navigationChat.elementId,
    }

    private static Profile = {
        key: 'about',
        label: 'Über mich',
        path: '/about',
        visible: true,
        icon: User,
        new_tab: false,
        // onboardingId: onboardingElementConfig.start.navigationChat.elementId,
    }

    private static Chat = {
        key: 'chat',
        label: 'Chat',
        path: '/chat',
        visible: true,
        icon: MessageCircle,
        new_tab: false,
        // onboardingId: onboardingElementConfig.start.navigationChat.elementId,
    }

    // private static Companies = {
    //     key: 'companies',
    //     label: 'Firmen',
    //     path: '/companies',
    //     visible: true,
    //     icon: Building2,
    //     new_tab: false,
    // }

    // private static StrengthsAnalysis = {
    //     key: 'strengths',
    //     name: 'Stärken',
    //     link: '/strengths',
    //     visible: true,
    //     icon: Sparkles,
    //     new_tab: false,
    //     // onboardingId: onboardingElementConfig.start.navigationPictureCreation.elementId,
    // }

    // private static Careers = {
    //     key: 'careers',
    //     name: 'Berufe',
    //     link: '/careers',
    //     visible: true,
    //     icon: Briefcase,
    //     new_tab: false,
    //     // onboardingId: onboardingElementConfig.start.navigationPictureCreation.elementId,
    // }

    // private static Tasks = {
    //     key: 'tasks',
    //     name: 'Aufgaben',
    //     link: '/tasks',
    //     visible: true,
    //     icon: Target,
    //     new_tab: false,
    //     // onboardingId: onboardingElementConfig.start.navigationPictureCreation.elementId,
    // }
}
